<template>
  <div id="tac-admin-payment-reconciliation-batch-transactions" class="batch-transactions">
    <amount-finder v-show="hasStarted"></amount-finder>
    <current-transactions v-show="hasTransactions || hasStarted"></current-transactions>
    <other-transactions v-show="hasStarted"></other-transactions>
  </div><!-- #tac-admin-payment-reconciliation-batch-transactions -->
</template>

<script>
  import AmountFinder from './AmountFinder'
  import CurrentTransactions from './CurrentTransactions'
  import OtherTransactions from './OtherTransactions'

  export default {
    name: 'transactions',
    computed: {
      hasTransactions() {
        return this.$store.getters['paymentReconciliation/batch/transactions'].length > 0
      },
      hasStarted() {
        return this.$store.getters['paymentReconciliation/amountFinder/started']
      }
    },
    components: {
      CurrentTransactions,
      OtherTransactions,
      AmountFinder
    }
  }
</script>
